import styles from './enquire.module.css'
import React, { Component } from 'react';
import PhoneInput from 'react-phone-number-input';
import { formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input';
import { onChange, setError, validateForm, validForm } from '../../utils';
import constant from '../../constant';

export default class OnlineSalesEnquiry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            NAME: { name: 'NAME', value: '', error: '', isRequired: true },
            MOBILE_NUMBER: { name: 'MOBILE_NUMBER', value: '', error: '', isRequired: true },
            COMPANY_NAME: { name: 'COMPANY_NAME', value: '', error: '', isRequired: true },
            DESIGNATION_NAME: { name: 'DESIGNATION_NAME', value: '', error: '', isRequired: true },
            EMAIL_ID: { name: 'EMAIL_ID', value: '', error: '', isRequired: true },
            CITY: { name: 'CITY', value: '', error: '', isRequired: true },
            LOOKING_FOR: { name: 'LOOKING_FOR', value: 'RECRUITMENT_SOLUTION', error: '', isRequired: true },
        };
    }

    onSubmit = (e) => {
        debugger
        e.preventDefault();
        const { MOBILE_NUMBER } = this.state;

        if (!isValidPhoneNumber(MOBILE_NUMBER.value)) {
            setError(this, MOBILE_NUMBER.name, 'Invalid phone number');
            return;
        }

        if (validForm(this)) {
            const { NAME, COMPANY_NAME, DESIGNATION_NAME, EMAIL_ID, CITY, LOOKING_FOR } = this.state;
            const formData = {
                NAME: NAME.value,
                MOBILE_NUMBER: formatPhoneNumberIntl(MOBILE_NUMBER.value),
                COMPANY_NAME: COMPANY_NAME.value,
                DESIGNATION_NAME: DESIGNATION_NAME.value,
                EMAIL_ID: EMAIL_ID.value,
                CITY: CITY.value,
                LOOKING_FOR: LOOKING_FOR.value,
            };
            this.props.onSubmit(formData);
        }
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value);
    };

    handlePhoneChange = (value) => {
        onChange(this, 'MOBILE_NUMBER', value);
    };

    handleRadioChange = (value) => {
        onChange(this, 'LOOKING_FOR', value);
    };

    render() {
        const { NAME, MOBILE_NUMBER, COMPANY_NAME, DESIGNATION_NAME, EMAIL_ID, CITY, LOOKING_FOR } = this.state;

        return (
            <div className={styles['hero-bg']}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-7">
                            <h5 className="my-4">
                                <span className={styles['hero-title']}>
                                    Your dream job is just a click away.
                                    <img src="https://cdn.jobzseed.com/employer/images/homepage/ai-animation.svg" className="ps-2" alt="AI animation" />
                                </span>
                            </h5>
                            <h1 className={styles['hero-heading']}>
                                Get in Touch with Us for <span className={styles['text-yellow']}>Any Queries</span>
                            </h1>
                            <p className={styles['hero-para']}>
                                Whether you have inquiries about our services, need support, or just want to share feedback, we'd love to hear from you.
                            </p>
                            <div className="mt-3">
                                <a href={constant.component.login.url} className={`${styles['login-btn']} btn`}>Login</a>
                                <a href={constant.component.register.url} className={`${styles['inquire-btn']} btn`}>Register</a>
                            </div>
                        </div>

                        <div className="col-md-5">
                            <form className={`${styles['contact-card']} card`} onSubmit={this.onSubmit}>
                                <div className="card-body">
                                    <h4 className={styles['post-title']}>Online Sales Enquiry</h4>

                                    <div className="my-2 ">
                                        {/* <label className="label-text">I am looking for</label> */}
                                        <div>
                                            <label htmlFor="radio-1" className="radio-trigger">
                                                <input
                                                    type="radio"
                                                    id="radio-1"
                                                    name="LOOKING_FOR"
                                                    checked={LOOKING_FOR.value === 'RECRUITMENT_SOLUTION'}
                                                    onChange={() => this.handleRadioChange('RECRUITMENT_SOLUTION')}
                                                />
                                                <span className="checkmark"></span>
                                                <span>Recruitment Solutions</span>
                                            </label>
                                            <label htmlFor="radio-2" className="radio-trigger ms-5">
                                                <input
                                                    type="radio"
                                                    id="radio-2"
                                                    name="LOOKING_FOR"
                                                    checked={LOOKING_FOR.value === 'JOB_POSTINGS'}
                                                    onChange={() => this.handleRadioChange('JOB_POSTINGS')}
                                                />
                                                <span className="checkmark"></span>
                                                <span>Job Postings</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3 position-relative">
                                            <input
                                                className={`form-control ${NAME.error ? 'is-invalid' : ''}`}
                                                type="text"
                                                name="NAME"
                                                value={NAME.value}
                                                onChange={this.handleInputChange}
                                                placeholder="Your Name"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3 position-relative">
                                            <PhoneInput
                                                className={`form-control ${MOBILE_NUMBER.error ? 'is-invalid' : ''}`}
                                                name="MOBILE_NUMBER"
                                                value={MOBILE_NUMBER.value}
                                                defaultCountry="IN"
                                                placeholder="Mobile"
                                                onChange={this.handlePhoneChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3 position-relative">
                                            <input
                                                className={`form-control ${COMPANY_NAME.error ? 'is-invalid' : ''}`}
                                                type="text"
                                                name="COMPANY_NAME"
                                                value={COMPANY_NAME.value}
                                                onChange={this.handleInputChange}
                                                placeholder="Your Company Name"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3 position-relative">
                                            <input
                                                className={`form-control ${DESIGNATION_NAME.error ? 'is-invalid' : ''}`}
                                                type="text"
                                                name="DESIGNATION_NAME"
                                                value={DESIGNATION_NAME.value}
                                                onChange={this.handleInputChange}
                                                placeholder="Designation Name"
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3 position-relative">
                                            <input
                                                className={`form-control ${EMAIL_ID.error ? 'is-invalid' : ''}`}
                                                type="email"
                                                name="EMAIL_ID"
                                                value={EMAIL_ID.value}
                                                onChange={this.handleInputChange}
                                                placeholder="Email ID"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3 position-relative">
                                            <input
                                                className={`form-control ${CITY.error ? 'is-invalid' : ''}`}
                                                type="text"
                                                name="CITY"
                                                value={CITY.value}
                                                onChange={this.handleInputChange}
                                                placeholder="City"
                                            />
                                        </div>
                                    </div>

                                    <button type="submit" className={`${styles['signin-btn']} btn w-100`}>Get a call back</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
